// extracted by mini-css-extract-plugin
export default {"saveButton":"TransferModal_saveButton__om7K1","hideButton":"TransferModal_hideButton__LDODE","modalContent":"TransferModal_modalContent__KSKRm"};